import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {RecordData} from "../../../../../types/records-table.types";
import {defaultRecordData} from "../../../../../models/default-record-data";
import {MatMiniFabButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-blogger-info',
  standalone: true,
  templateUrl: './blogger-info.component.html',
  imports: [
    MatMiniFabButton,
    MatIcon
  ],
  styleUrl: './blogger-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloggerInfoComponent {
  bloggerData = input<RecordData>(defaultRecordData);
  handleOpenBloggerModal = output<void>();

  public handleOpenBloggerClick(): void {
    this.handleOpenBloggerModal.emit();
  }
}
